export default "__VITE_ASSET__BomFjwcN__"